<template>
  <!-- :class="footerActive == 0 ? 'footer footerBc' : 'footer'" -->
  <div class="footer">
    <div class="robotBox">
      <el-popover
        placement="left"
        title=""
        width="288"
        trigger="hover"
        content=""
      >
        <div class="contactBox">
          <div class="subTitle">联系我们</div>
          <div class="footFlexRow">
            <div class="footLeft">
              <img src="@/assets/image/footer/1.png" alt="" />
            </div>
            <div class="footRight">
              <span>客服电话</span>
              <p>
                <span class="hightLsi">18588971069 </span>
                或
                <span class="hightLsi">0755-23994888</span>
              </p>
            </div>
          </div>
          <div class="footFlexRow">
            <div class="footLeft">
              <img src="@/assets/image/footer/2.png" alt="" />
            </div>
            <div class="footRight">
              <span>微信客服</span>
              <img
                class="width108"
                src="@/assets/image/footer/weixin-service.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div slot="reference" class="flexColume cycle11">
          <img src="@/assets/image/footer/phone.png" alt="" />
          <span>联系我们</span>
        </div>
      </el-popover>
      <div class="showfeedbackBox">
        <el-popover
          placement="left"
          title=""
          width="288"
          trigger="hover"
          content=""
        >
          <div class="formBox2">
            <div class="subTi"></div>
            <el-form :model="form">
              <el-form-item>
                <el-select
                  style="width: 100%"
                  v-model="form.type"
                  placeholder="请选择预约演示的产品"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.label"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  placeholder="姓名"
                  maxlength="50"
                  v-model="form.name"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  placeholder="公司名称"
                  v-model="form.companyName"
                  maxlength="100"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  placeholder="手机号码"
                  v-model="form.phone"
                  maxlength="20"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  placeholder="备注"
                  maxlength="300"
                  type="textarea"
                  v-model="form.message"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <div class="submitBtn" @click="submit">提交</div>
              </el-form-item>
            </el-form>
          </div>
          <div slot="reference" class="flexColume2">
            <img
              class="defaultImg"
              src="@/assets/image/footer/tvshow.png"
              alt=""
            />
            <img
              class="activeImg"
              src="@/assets/image/footer/tvshow_xuanfu.png"
              alt=""
            />
            <span>演示</span>
          </div>
        </el-popover>
        <el-popover
          placement="left"
          title=""
          width="210"
          trigger="hover"
          content=""
        >
          <div class="mailImg">
            <p class="tite">意见邮箱</p>
            <div class="info">
              <span>heyy@waitrans.com</span>
              <img
                @click="copyEmail()"
                src="@/assets/image/footer/copy.png"
                alt=""
              />
            </div>
          </div>
          <div slot="reference" class="flexColume2">
            <img
              class="defaultImg"
              src="@/assets/image/footer/edit.png"
              alt=""
            />
            <img
              class="activeImg"
              src="@/assets/image/footer/edit_xuanfu.png"
              alt=""
            />
            <span>反馈</span>
          </div>
        </el-popover>
      </div>
      <div class="backtop" ref="backtop" @click="backTop">
        <img src="@/assets/image/footer/top.png" class="defaultImg" alt="" />
        <img
          src="@/assets/image/footer/top_xuanfu.png"
          class="activeImg"
          alt=""
        />
      </div>
    </div>
    <div class="footerBox">
      <!--  :class="footerActive == 0 ? 'footer_top textTitle' : 'footer_top'" -->
      <div class="footer_top">
        {{ title }}
      </div>
      <!--  :style="footerActive == 0 ? 'border-bottom:1px solid #999999' : ''" -->
      <div class="footer_center">
        <div class="footer_proService">
          <!-- :style="footerActive == 0 ? 'color: #999999;' : ''" -->
          <h3>产品服务</h3>
          <div class="txt">
            <p
              v-for="(item, index) in chanFuList"
              :key="index"
              @click="changeRoute('product', item.num)"
            >
              {{ item.txt }}
            </p>
          </div>
        </div>
        <div class="footer_solutionPlan">
          <!-- :style="footerActive == 0 ? 'color: #999999;' : ''" -->
          <h3>解决方案</h3>
          <!-- :class="footerActive == 0 ? 'txt textColor' : 'txt'" -->
          <div class="txt">
            <p
              v-for="(item, index) in jiejueList"
              :key="index"
              @click="changeRoute('solution', index)"
            >
              {{ item.txt }}
            </p>
          </div>
        </div>
        <div class="footer_devIntegration">
          <h3>云译商城</h3>
          <div class="txt">
            <p
              v-for="(item, index) in shoppingList"
              :key="index"
              @click="changeRoute('shopping', item.inx)"
            >
              {{ item.txt }}
            </p>
          </div>
        </div>
        <div class="footer_TrendsofConsultation">
          <h3>支持与服务</h3>
          <div class="txt">
            <p
              v-for="(item, index) in supportList"
              :key="index"
              @click="changeRoute('support', item.type, 1)"
            >
              {{ item.tit }}
            </p>
          </div>
        </div>
        <div class="footer_aboutUs">
          <h3>关于云译</h3>
          <div class="txt">
            <p
              v-for="(item, index) in guanyuList"
              :key="index"
              @click="changeRoute('about', item.type, 0)"
            >
              {{ item.tit }}
            </p>
          </div>
        </div>
      </div>
      <div class="footer_bottom">
        <div class="info">
          <!-- :class="footerActive == 0 ? 'leftInfo textColor' : 'leftInfo'" -->
          <div class="leftInfo">
            <!-- <span @click="goPage(1)">用户协议</span>
            <span class="dianji" @click="goPage(2)">隐私政策</span> -->
          </div>
          <div class="rightImg">
            <div class="flex-row1">
              <div v-for="(it, inx) in logoImgs" :key="inx" class="outdiv">
                <div :class="`item${inx + 1}`">
                  <img :src="it.imgUrl" alt="" />
                </div>
                <img :src="it.qrcodeUrl" alt="" class="img2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- :class="footerActive == 0 ? 'footerLast footerLast1' : 'footerLast'" -->
    <div class="footerLast">
      <div class="foot_info">
        <span
          >Copyright © 深圳云译科技有限公司{{ new Date().getFullYear() }}</span
        >
        <span class="text">粤公网安备 44030502008825号</span>
        <span class="text">粤ICP备18097972号</span>
        <span class="text"
          >地址：深圳市南山区高新南七道6号数字技术园B2栋4楼A区</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { sendMessage } from "@/api/about/index.js";
export default {
  name: "foot_er",
  props: {
    footerActive: {
      type: Number,
      default: -1,
    },
  },

  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "文本文档翻译",
        },
        {
          value: "选项2",
          label: "音视频翻译",
        },
        {
          value: "选项3",
          label: "同声传译",
        },
        {
          value: "选项4",
          label: "翻译语言教学系统",
        },
        {
          value: "选项5",
          label: "外翻资源信息管理系统",
        },
        {
          value: "选项6",
          label: "翻译项目管理",
        },
        {
          value: "选项7",
          label: "离线手持终端",
        },
        {
          value: "选项8",
          label: "语料管理",
        },
        {
          value: "选项9",
          label: "知识图谱",
        },
        {
          value: "选项10",
          label: "插件",
        },
        {
          value: "选项11",
          label: "文本翻译API",
        },
        {
          value: "选项16",
          label: "文档翻译API",
        },
        {
          value: "选项12",
          label: "语种自动识别接口",
        },
        {
          value: "选项13",
          label: "音视频转写服务",
        },
        {
          value: "选项14",
          label: "音视频翻译服务",
        },
        {
          value: "选项15",
          label: "视频配音服务",
        },
      ],
      chanFuList: [
        {
          txt: "文本文档翻译",
          num: "0",
        },
        {
          txt: "音视频翻译",
          num: "1",
        },
        {
          txt: "AI同声传译",
          num: "2",
        },
        {
          txt: "笔译教学",
          num: "17",
        },
        {
          txt: "口译教学",
          num: "18",
        },
        // {
        //   txt: "查看更多...",
        //   num: "5",
        // },
      ],
      jiejueList: [
        {
          txt: "高校教育",
        },
        {
          txt: "IT通讯",
        },
        {
          txt: "医疗药学",
        },
        {
          txt: "金融财经",
        },
      ],
      shoppingList: [
        {
          txt: "实训课程",
          inx: 0,
        },
        {
          inx: 1,
          txt: "CATTI",
        },
      ],
      supportList: [
        {
          tit: "文本翻译API",
          txt: "可接入APP、网站及智能设备",
          type: "10",
          imgUrl: require("@/assets/image/support/liebiao/api.png"),
        },
        {
          tit: "文档翻译API",
          txt: "可接入APP、网站及智能设备",
          type: "11",
          imgUrl: require("@/assets/image/support/liebiao/api.png"),
        },
        {
          tit: "语种自动识别接口",
          txt: "精准识别文本语种并返回语种结果",
          type: "12",
          imgUrl: require("@/assets/image/support/liebiao/interface.png"),
        },
        {
          tit: "音视频翻译服务",
          txt: "可根据需求提供定制化的人工服务",
          type: "14",
          imgUrl: require("@/assets/image/support/liebiao/video.png"),
        },
        {
          tit: "文本翻译服务",
          txt: "可根据需求提供定制化的人工服务",
          type: "14",
          imgUrl: require("@/assets/image/support/liebiao/text.png"),
        },
      ],

      guanyuList: [
        {
          tit: "公司简介",
          txt: "行业领先的自然语言处理解决方案提供商",
          type: 0,
          imgUrl: require("@/assets/image/guanyu/liebiao/introduction.png"),
        },
        {
          tit: "资讯动态",
          txt: "产品宣传、公司动态、行业资讯",
          type: 1,
          imgUrl: require("@/assets/image/guanyu/liebiao/zixun.png"),
        },
        {
          tit: "招聘岗位",
          txt: "邮箱：hr@waitrans.com",
          type: 3,
          imgUrl: require("@/assets/image/guanyu/liebiao/job.png"),
        },
        {
          tit: "联系我们",
          txt: "电话：0755-23994888",
          type: 2,
          imgUrl: require("@/assets/image/guanyu/liebiao/call.png"),
        },
      ],
      logoImgs: [
        {
          name: "weixin",
          imgUrl: require("@/assets/image/footer/weixin.png"),
          qrcodeUrl: require("@/assets/image/footer/gongzhonghao.png"),
        },
        {
          name: "shipinhao",
          imgUrl: require("@/assets/image/footer/shipinhao.png"),
          qrcodeUrl: require("@/assets/image/footer/shipinghao.png"),
        },
        {
          name: "douyin",
          imgUrl: require("@/assets/image/footer/douyin.png"),
          qrcodeUrl: require("@/assets/image/footer/douyinhao.png"),
        },
      ],
      title: "首页",
      form: {
        message: "",
        name: "",
        type: "",
        phone: "",
        companyName: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.topHandle();
    this.changeTitle();
  },
  methods: {
    topHandle() {
      let _this = this;
      document.addEventListener("scroll", function () {
        if (window.scrollY > 600 || document.documentElement.scrollTop > 600) {
          if (_this.$refs.backtop) {
            _this.$refs.backtop.style.opacity = 1;
          }
        } else {
          if (_this.$refs.backtop) {
            _this.$refs.backtop.style.opacity = 0;
          }
        }
      });
    },
    backTop() {
      window.scrollTo(0, 0);
    },
    submit() {
      if (!this.form.name) {
        this.$message.warning("请输入姓名！");
        return;
      }
      if (!this.form.companyName) {
        this.$message.warning("请输入公司名称！");
        return;
      }
      if (!this.form.phone) {
        this.$message.warning("请输入手机号码！");
        return;
      }
      sendMessage(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.data);
          this.form = {
            message: "",
            name: "",
            type: "",
            phone: "",
            companyName: "",
          };
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    copyEmail() {
      let data = "heyy@waitrans.com";
      this.copy(data);
    },
    copy(data) {
      let elInput = document.createElement("input");
      elInput.value = data;
      document.body.appendChild(elInput);
      // 选择对象
      elInput.select();
      // 执行浏览器复制命令
      this.$message.success("复制成功！");
      document.execCommand("Copy");
      elInput.remove();
    },
    changeTitle() {
      this.title = this.$route.meta.title;
      // switch (this.footerActive) {
      //   case 0:
      //     this.title = "首页";
      //     break;
      //   case 1:
      //     this.title = "文本机器翻译";
      //     break;
      //   case 2:
      //     this.title = "产品服务";
      //     break;
      //   case 3:
      //     this.title = "解决方案";
      //     break;
      //   case 4:
      //     this.title = "云译商城";
      //     break;
      //   case -1:
      //     this.title = "用户协议";
      //     break;
      //   case -2:
      //     this.title = "隐私政策";
      //     break;
      // }
    },
    // 进入协议页面
    goPage(type) {
      if (type == 1) {
        this.$router.push("/agreement");
      } else {
        this.$router.push("/privacyPolicy");
      }
    },
    // 跳转对应页面
    changeRoute(path, inx, sign) {
      console.log(path, inx, "ind");
      if (path == "about" && inx == 3) {
        this.$router.push("/recruitment");
      } else {
        window.scrollTo(0, 0);

        localStorage.setItem(path, inx);
        console.log(sign, "111");
        if (sign != null) {
          this.$router.push({
            path: "/" + path,
            query: {
              type: sign,
            },
          });
        } else {
          this.$router.push("/" + path);
        }
        if (this.$route.name === path) {
          this.$router.go(0);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.backtop {
  width: 48px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(155, 165, 190, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  margin-top: 16px;
  .defaultImg {
    display: block;
  }
  .activeImg {
    display: none;
  }
}
.backtop:hover {
  .defaultImg {
    display: none;
  }
  .activeImg {
    display: block;
  }
}
.formBox2 {
  .subTi {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #93969d;
    margin-bottom: 16px;
  }
  .submitBtn {
    width: 128px;
    height: 36px;
    background: #3466ef;
    border-radius: 4px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    cursor: pointer;
  }
}
.contactBox {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  .subTitle {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #93969d;
  }
  .width108 {
    width: 108px;
    height: 108px;
    margin-top: 4px;
  }
  .footFlexRow {
    margin-top: 25px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    color: #5f636c;
    line-height: 22px;
    .footLeft {
      width: 24px;
      margin-right: 12px;
      img {
        width: 24px;
      }
    }
    .footRight {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #5f636c;
      line-height: 22px;
      p {
        margin-top: 4px;
      }
      .hightLsi {
        color: #353941;
      }
    }
  }
}
.showfeedbackBox {
  margin-top: 16px;
  width: 48px;
  height: 133px;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(155, 165, 190, 0.2);
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .flexColume2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 5px;
    }
    span {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #363c4b;
    }
    .defaultImg {
      display: block;
    }
    .activeImg {
      display: none;
    }
  }
  .flexColume2:hover {
    span {
      color: #3466ef;
    }
    .defaultImg {
      display: none;
    }
    .activeImg {
      display: block;
    }
  }
}
.mailImg {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4e6274;
  .info {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #5f636c;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    span {
      margin-right: 6px;
    }
    img {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
}
.robotBox {
  z-index: 333;
  position: fixed;
  top: 49%;
  right: 0;
  width: 63px;
  .flexColume {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 20px;
      height: 20px;
      margin-bottom: 10px;
    }
    span {
      display: inline-block;
      text-align: center;
      width: 20px;
    }
  }
  .cycle11 {
    width: 48px;
    height: 126px;
    background: #3466ef;
    box-shadow: 0px 4px 12px 0px rgba(155, 165, 190, 0.2);
    border-radius: 25px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    cursor: pointer;
  }
  .cycle11:hover {
    opacity: 0.8;
  }
}
.footer {
  background: #f2f2f2;
  // position: absolute;
  width: 100%;
  // bottom: -77px;
}
.footerBc {
  background: #28292d;
}
.footerBox {
  margin: 0 auto;
  @media screen and (min-width: 1910px) {
    width: 1400px;
  }
  @media screen and (min-width: 1720px) and (max-width: 1910px) {
    width: 1300px;
  }
  @media screen and (min-width: 1520px) and (max-width: 1720px) {
    width: 1200px;
  }
  @media screen and (min-width: 1220px) and (max-width: 1520px) {
    width: 1000px;
  }
  @media screen and (max-width: 1200px) and (max-width: 1220px) {
    width: 800px;
  }
  .footer_top {
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #595757;
    height: 84px;
  }
  .footer_center {
    width: 100%;
    height: 416px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e2e2e2;
    padding-top: 54px;
    box-sizing: border-box;
    h3 {
      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #333333;
    }
    .txt {
      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #595757;
      margin-top: 33px;
      line-height: 39px;
      p {
        cursor: pointer;
      }
      p:hover {
        color: #242a3b;
      }
    }
  }
  .footer_bottom {
    height: 100px;
    display: flex;
    align-items: center;
    .info {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .leftInfo {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #595757;
      cursor: pointer;
      .dianji {
        margin-left: 30px;
      }
    }

    .flex-row1 {
      display: flex;
    }
    .item1,
    .item2,
    .item3 {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: #a4a5a8;
    }
    .outdiv {
      width: 50px;
      position: relative;
      cursor: pointer;
      &:hover .img2 {
        display: block;
        position: absolute;
        left: -100%;
        bottom: 35px;
        background: #ffffff;
        box-shadow: 7px 7px 6px 0px rgba(0, 0, 0, 0.08);
      }
    }
    .outdiv:hover .item1 {
      background-color: #09bb07;
    }
    .outdiv:hover .item2 {
      background-color: #ffa61c;
    }
    .outdiv:hover .item3 {
      background-color: #140b19;
    }
    .img2 {
      display: none;
    }
  }
}
.footerLast {
  height: 50px;
  background: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  .text {
    margin-left: 23px;
  }
}
.footerLast1 {
  background: #1f2126;
}
.textColor {
  color: #999999 !important;
}
.textTitle {
  color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
}
</style>
